import { useEffect, useState } from "react";
import { sharedData } from "../sharedData/sharedData";

// The entity id of the request currently being worked on, kept in step as it changes.
//
// It is not always known when a page mounts: on a new request Client/Counterparty creates the
// entity, and on some entry paths the id lands in sharedData a moment after the first render.
// Pages that read it once — `useMemo(() => sharedData.get("entityId"), [])` — froze whatever was
// there at that instant, so a late id was never seen, the fetch keyed on it never re-ran, and the
// page stayed empty until it was mounted again. Subscribing fixes that for every page that needs
// the id in a dependency array.
//
// Pages that read `sharedData.get("entityId")` inside the effect that uses it are already correct
// and do not need this.
export const useEntityId = () => {
  const [entityId, setEntityId] = useState(() => sharedData.get("entityId"));

  // subscribe() invokes the callback with the current value straight away and returns its
  // own unsubscribe function, which is exactly the cleanup useEffect wants.
  useEffect(() => sharedData.subscribe("entityId", setEntityId), []);

  return entityId;
};
